import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace } from '../../model';

export const trackClickGiftSectionEvent = (isOpen: boolean, time: number) => {
  const action = isOpen
    ? EcommerceSectionNamespace.EEcommerceAction.CLOSE_GIFTS
    : EcommerceSectionNamespace.EEcommerceAction.OPEN_GIFTS;
  const mode = isOpen ? EcommerceSectionNamespace.EEcommerceMode.CLOSE : EcommerceSectionNamespace.EEcommerceMode.OPEN;

  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.ELEMENT_CLICK,
      element: {
        type: EcommerceSectionNamespace.EEcommerceType.GIFTS,
        action: action,
        interaction: EcommerceSectionNamespace.EEcommerceInteraction.CLICK,
        name: EcommerceSectionNamespace.EEcommerceName.GIFTS,
        mode: mode,
        timing: time,
      },
      _clear: true,
    }),
  );
};
